import request from '@/common/request'

// ---------------------------系统设置 -- 药房管理------------------------------
// 药房列表
export const getStoreList = (params) => {
  return request.get('/system/store/list', { params })
}
// 添加药房
export const getStoreAdd = (data) => {
  return request.post('/system/store/add', data )
}
// 药房修改
export const upDataStore = (data) => {
  return request.post('/system/store/update', data )
}
// 药房结算比例日志
export const pageMedStoreLog = (params) => {
  return request.get('/system/store/pageMedStoreLog', { params })
}
// 药房删除
export const storeDel = (data) => {
  return request.post('/system/store/del', data )
}
// ------------------系统设置 -- 角色管理-----------------------------
// 角色管理
export const getRoleList = (params) => {
  return request.get('/system/role/list', { params })
}
// 角色添加
export const getRoleAdd = (data) => {
  return request.post('/system/role/add', data )
}
// 角色修改
export const upDataRole = (data) => {
  return request.post('/system/role/update', data )
}
// 角色删除
export const roleDel = (params) => {
  return request.get('/system/role/del', { params })
}
// 权限列表
export const roleFuncList = (params) => {
  return request.get('/system/func/list', { params })
  // return request.get('/system/role/funcList', { params })
}
// 权限保存
export const roleSaveFunc = (data) => {
  // return request.post('/system/role/givefunc', data )
  return request.post('/system/role/saveFunc', data )
}
// 权限回显
export const getFunc = (params) => {
  return request.get('/system/role/getFunc', { params })
  // return request.get('/system/role/getRoleFunc', { params })
}
// -------------------------系统设置 -- 员工管理----------------------------------------
// 用户列表
export const getUserList = (params) => {
  return request.get('/system/user/list', { params })
}
// 用户添加
export const getUserAdd = (data) => {
  return request.post('/system/user/add', data )
}
// 用户修改
export const getUserUpdate = (data) => {
  return request.post('/system/user/update', data )
}
// 修改密码
export const upDatePass = (data) => {
  return request.post('/updatePass', data )
}
// 员工刪除
export const delUserInfomation = (params) => {
  return request.get('/system/user/del', { params })
}
// --------------------系统设置 -- 供应商管理-----------------------------
// 供应商列表
export const supManagement = (data) => {
  return request.post('/vendor/list', data )
}
// 供应商添加
export const addManagement = (data) => {
  return request.post('/vendor/addOrUpdate', data )
}
// 供应商刪除
export const delManagement = (params) => {
  return request.get('/vendor/delete', { params })
}
// 供应商状态更改
export const updValidManagement = (params) => {
  return request.get('/vendor/status', { params })
}
// 字典管理列表
export const getDictList = (params) => {
  return request.get('/medicineDict/list', { params })
}
// 字典管理添加
export const getDictAdd = (data) => {
  return request.post('/medicineDict/add', data )
}
export const uploadImg = (data) => {
  return request.post('/uploadImg', data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

